export const GET_DEVICE_EV_LIST = 'GET_DEVICE_EV_LIST';
export const SET_DEVICE_EV_LIST = 'SET_DEVICE_EV_LIST';
export const GET_EVENT_LIST = 'GET_EVENT_LIST';
export const SET_EVENT_LIST = 'SET_EVENT_LIST';
export const SET_SELECTED_SN = 'SET_SELECTED_EVENT';
export const GET_EVENT_DETAIL = 'GET_EVENT_DETAIL';
export const SET_EVENT_DETAIL = 'SET_EVENT_DETAIL';
export const GET_EV_LIST_EXCEL_DOWN = 'GET_EV_LIST_EXCEL_DOWN';
export const GET_EV_LIST_ALL_EXCEL_DOWN = 'GET_EV_LIST_ALL_EXCEL_DOWN';
